import {combineReducers} from "@reduxjs/toolkit"
// import AddTask from "@src/views/add-task"
import dialogReducer from "@slices/dialog.slice"
import authReducer from "@slices/auth.slice"
import configReducer from "@slices/config.slice"
// import  dashboardReducer from "@slices/dashboard.slice"

import brokerReducer from "@slices/broker.slice"
import productsReducer from "@views/master-data/slices/product.slice"
import usersReducer from "@views/master-data/slices/user.slice"
import modelsReducer from "@views/master-data/slices/model.slice"

import traceabilityApi from "@src/redux/services/traceabilityApi";
import packageReducer from "@src/redux/slices/package.slice"


const rootReducer = combineReducers({
    dialogs: dialogReducer,
    auth: authReducer,
    config: configReducer,
    broker: brokerReducer,
    products: productsReducer,
    users: usersReducer,
    models: modelsReducer,
    packages: packageReducer,
    [traceabilityApi.reducerPath]: traceabilityApi.reducer,
    // dashboard: dashboardReducer,
})

export default rootReducer
